import { Grid, FormControl, Box, Typography, TextField, Chip, Tooltip } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import CommonDatePicker from "../../../../Base/views/CommonDatePicker";
import MaterialTable from "material-table";
import {
  ConvertDate,
  DateConvertInDbFormat,
} from "../../../../Base/helper/baseFunctions";
import BackdropMeepl from "../../../../Ancillary/AnimationComponents/BackdropMeepl";
import {
  DeleteMyAttendancePermissionAction,
  GetMyAttendancePermissionAction,
  UpsertMyAttendancePermissionAction,
} from "../../../../../../store/Leave/MyAttendancePermission/Action";
import AddIcon from "@mui/icons-material/Add";
import SelectableSearch from "../../../../Base/views/SelectableSearch";
import { GetEmployeesAction } from "../../../../../../store/Employee/Employee/Action";
import DeleteIcon from "@mui/icons-material/Delete";
import CommentIcon from '@mui/icons-material/Comment';

const TeamPermission = () => {
  const dispatch = useDispatch();
  const date = new Date();
  const { isLoading, my_attendance_permission } = useSelector(
    (state) => state?.LeaveReducer?.MyAttendancePermissionReducer,
  );
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer,
  );
  const { atsModuleData } = useSelector((state) => state?.RoleAndAccessReducer?.ATSModuleReducer);
  const ExternalUserCoreHr = atsModuleData?.some((item) => item.module_name === "External User CoreHr");

  const [filters, setFilters] = useState({
    month_year: `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()}`,
    ats_work_location_id: [],
  });
  const [f_year, f_month] = filters.month_year.split("-");
  const startOfMonth = new Date(f_year, f_month - 1, 1);
  const endOfMonth = new Date(f_year, f_month, 0);
  const { employees_options } = useSelector(
    (state) => state.EmployeeReducer.EmployeesReducer,
  );
  const [employeesData, setEmployeesData] = useState({
    load: true,
    values: [],
  });

  const handleEmployees = () => {
      employees_options &&
          setEmployeesData({ load: false, values: employees_options });

  };
  const formatDataStructure = (data) => {
    if (!data || data.length === 0) return [];

    return data?.map((employee) => {
      return {
        ...employee,
        employee_id: {
          employee_id: employee?.employee_id,
          name: employee?.emp_name,
        },
      };
    });
  };
  const employeePermissionRows =
    formatDataStructure(my_attendance_permission) || [];
  const fetchData = () => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    dispatch(
      GetMyAttendancePermissionAction({
        month: f_month,
        year: f_year,
        tab: "Team"
      }),
    );
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);
  useEffect(() => {
      dispatch(GetEmployeesAction({ is_active: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmitRowData = (rowData, actionType) => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();

    if (actionType === "edit" && rowData?.employee_id) {
      dispatch(
        UpsertMyAttendancePermissionAction(
          {
            ...rowData,
            employee_fk: rowData?.employee_id?.employee_id,
            month: f_month,
            year: f_year,
            record_date: rowData?.record_date
              ? rowData?.record_date
              : DateConvertInDbFormat(startOfMonth),
            status: rowData?.status === "Rejected" ? "Submitted" : rowData?.status,
            actionType,
          },
          (res, err) => {
            if (res && !err) {
              fetchData();
            }
          },
        ),
      );
    } else if (actionType === "add") {
      dispatch(
        UpsertMyAttendancePermissionAction(
          {
            ...rowData,
            employee_fk: rowData?.employee_id?.employee_id,
            month: f_month,
            year: f_year,
            record_date: rowData?.record_date
              ? rowData?.record_date
              : DateConvertInDbFormat(startOfMonth),
            status: "Submitted",
            actionType,
          },
          (res, err) => {
            if (res && !err) {
              fetchData();
            }
          },
        ),
      );
    } else if (actionType === "delete") {
      dispatch(
        DeleteMyAttendancePermissionAction(
          {
            employee_permission_mapping_pk:
              rowData?.employee_permission_mapping_pk,
            month: f_month,
            year: f_year,
          },
          (res, err) => {
            if (res && !err) {
              fetchData();
            }
          },
        ),
      );
    } else {
      console.log("Invalid action type:", actionType);
    }
  };

  const handleFilter = (event, value) => {
    if (["month_year"].includes(event?.target?.name)) {
      setFilters({ ...filters, [event?.target?.name]: event?.target?.value });
    }
  };
  const titleContent = (
    <Box>
      <Typography variant="h6" fontWeight={600}>
        Employee
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Manage permissions applied by employees for above month/year selection
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        maxHeight: "calc(100vh - 85px)",
        overflowY: "auto",
      }}
    >
      <Grid py={1} container alignItems="center">
        <Grid item>
          <FormControl>
            <CommonDatePicker
              name="month_year"
              openTo="month"
              views={["year", "month"]}
              label="Month and Year"
              pickerType="date"
              size="small"
              onKeyDown={(e) => e.preventDefault()}
              onKeyPress={(e) => e.preventDefault()}
              pickerFormat="MM/yyyy"
              DefaultDTvalue={filters.month_year}
              maxDate={
                new Date(new Date().getFullYear(), new Date().getMonth() + 2, 1)
              }
              minDate={
                new Date(
                  new Date(minDojYear).setFullYear(
                    new Date(minDojYear).getFullYear() - 1,
                  ),
                )
              }
              handleChange={(value) =>
                handleFilter({
                  target: {
                    name: "month_year",
                    value: value
                      ? `${value?.getFullYear()}-${(
                          "0" +
                          (value?.getMonth() + 1)
                        ).slice(-2)}-${("0" + value?.getDate()).slice(-2)}`
                      : "",
                  },
                })
              }
            />
          </FormControl>
        </Grid>
      </Grid>
      <Box sx={{ position: "relative" }}>
        <MaterialTable
          isLoading={isLoading}
          columns={[
            {
              title: "Date",
              headerStyle: {
                textAlign: "start",
                paddingLeft: "2%",
              },
              cellStyle: {
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              field: "record_date",
              grouping: false,
              render: (rowData) =>
                rowData?.record_date ? ConvertDate(rowData?.record_date) : "",
              editComponent: (props) => {
                const isEdit = props.rowData?.tableData?.editing === "update";
                return (
                  <Box sx={{ width: "90%", ml: -2, pt: 0.5 }}>
                    <FormControl fullWidth>
                      <CommonDatePicker
                        disabled={isEdit}
                        size="small"
                        name="record_date"
                        pickerType="date"
                        onKeyPress={(e) => e.preventDefault()}
                        onKeyDown={(e) => e.preventDefault()}
                        required={true}
                        pickerFormat="dd/MM/yyyy"
                        DefaultDTvalue={
                          props.value ? props.value : startOfMonth
                        }
                        minDate={startOfMonth}
                        maxDate={endOfMonth}
                        handleChange={(value) => {
                          props.onChange(DateConvertInDbFormat(value));
                        }}
                      />
                    </FormControl>
                  </Box>
                );
              },
            },
            {
              title: "Employee",
              headerStyle: {
                textAlign: "start",
                paddingLeft: "2%",
              },
              cellStyle: {
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              field: "employee_id",
              grouping: false,
              validate: (rowData) => {
                if (rowData.employee_id?.name) {
                  return "";
                } else {
                  return "Employee cannot be empty";
                }
              },
              render: (rowData) => rowData.employee_id?.name || "",
              editComponent: (props) => {
                const isEdit = props.rowData?.tableData?.editing === "update";
                return (
                  <Box sx={{ width: "100%", mb: -0.5 }}>
                    <SelectableSearch
                      fullWidth
                      variantType="standard"
                      size="small"
                      disabled={isEdit}
                      loading={() => handleEmployees()}
                      placeholder="Select Employee"
                      value={props.value}
                      fieldLabel="name"
                      name="employee_id"
                      onChangeEvent={(e, v) => {
                        props.onChange(v);
                      }}
                      data={employeesData}
                    />
                  </Box>
                );
              },
              customFilterAndSearch: (search, rowData) =>
                (rowData?.employee_id?.name || "")
                  .toLowerCase()
                  .includes(search.toLowerCase()),
            },
            {
              title: "Permission Hours",
              field: "daily_hours",
              headerStyle: {
                textAlign: "start",
                paddingLeft: "1%",
              },
              cellStyle: {
                textAlign: "start",
                padding: "0px 0px 0px 2%",
              },
              validate: (rowData) => {
                if (rowData?.daily_hours) {
                  return "";
                } else {
                  return "Amount cannot be empty";
                }
              },
              editComponent: (props) => {
                return (
                  <Box width={"100%"}>
                    <TextField
                      required={true}
                      type="number"
                      variant="standard"
                      placeholder="Enter Hours"
                      value={props?.value}
                      inputProps={{ min: 0 }}
                      onChange={(e) => {
                        if (
                          Number(e.target.value) < 0 ||
                          Number(e.target.value) > 24
                        )
                          return;
                        props.onChange(e.target.value);
                      }}
                    />
                  </Box>
                );
              },
            },
            {
              field: "status",
              title: "Status",
              editable: "never",
              headerStyle: {
                textAlign: "start",
                paddingLeft: "2%",
              },
              cellStyle: {
                textAlign: "start",
                padding: "0px 0px 0px 4px",
              },
              render: (rowData) => {
                const { bg, text } = getStatusColor(rowData?.status);
                return (
                  <Chip
                    label={rowData.status}
                    style={{
                      backgroundColor: bg,
                      color: text,
                      fontWeight: 500,
                    }}
                    size="small"
                  />
                );
              },
            },
            {
              field: "comments",
              title: "Approver Comment",
              editable: "never",
              headerStyle: {
                textAlign: "start",
              },
              cellStyle: {
                textAlign: "start",
                padding: "5px 0px 5px 30px",
              },
              sorting: false,
              render: (rowData) => {
                return (
                  <Box width={"90%"}>
                    <tooltip title={rowData?.comments || ""} arrow>
                      <CommentIcon sx={{
                        fontSize: "20px",
                        color: rowData?.comments ? "#637381" : "#95a0ab",
                        cursor: rowData?.comments ? "pointer" : "default",
                      }} />
                    </tooltip>
                  </Box>
                );
              },
            },
          ]}
          data={employeePermissionRows || []}
          options={{
            maxBodyHeight: "calc(100vh - 335px)",
            minBodyHeight: "calc(100vh - 335px)",
            rowStyle: { fontSize: "13px", height: "30px" },
            headerStyle: {
              padding: "7px 0px 7px 0px",
              fontWeight: "bold",
            },
            sorting: true,
            search: true,
            searchText: "",
            searchFieldAlignment: "right",
            searchAutoFocus: false,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: false,
            exportAllData: false,
            addRowPosition: "first",
            selection: false,
            actionsColumnIndex: -1,
            showSelectAllCheckbox: false,
            showTextRowsSelected: false,
            grouping: false,
            columnsButton: false,
          }}
          icons={{
            Add: () => <AddIcon sx={{ color: "#637381" }} />,
            Edit: (props) => <EditIcon sx={{ color: props?.disabled ? "#bdbdbd" : "#637381" }} />,
            Delete: (props) => <DeleteIcon sx={{ color: props?.disabled ? "#bdbdbd" : "#637381" }} />
          }}
          editable={{
            isEditable: rowData => rowData?.status === "Rejected" && !ExternalUserCoreHr,
            isDeletable: rowData => rowData?.status === "Rejected" && !ExternalUserCoreHr,
            onRowAdd: !ExternalUserCoreHr ? (newRow) =>
              new Promise((resolve, reject) => {
                if (!newRow?.daily_hours || !newRow?.employee_id) {
                  return reject();
                }
                handleSubmitRowData(newRow, "add");
                setTimeout(() => resolve(), 500);
              }) : undefined,
            onRowUpdate: (newRow, oldRow) =>
              new Promise((resolve, reject) => {
                if (!newRow?.daily_hours || !newRow?.employee_id) {
                  return reject();
                }
                handleSubmitRowData(newRow, "edit");
                setTimeout(() => resolve(), 500);
              }),
            onRowDelete: (selectedRow) =>
              new Promise((resolve, reject) => {
                handleSubmitRowData(selectedRow, "delete");
                setTimeout(() => resolve(), 1000);
              }),
          }}
          components={{
            Overlay: () => null,
            OverlayLoading: () => <BackdropMeepl open={true} dark={false} />,
          }}
          title={titleContent}
        />
      </Box>
    </Box>
  );
};
const getStatusColor = (status) => {
  switch (status) {
    case "Pending Approval":
      return { bg: "#FFF4E5", text: "#FFA726" }; // yellow
    case "Approved":
      return { bg: "#E8F5E9", text: "#66BB6A" }; // green
    case "Rejected":
      return { bg: "#FFEBEE", text: "#EF5350" }; // red
    case "Submitted":
      return { bg: "#E3F2FD", text: "#42A5F5" };
    default:
      return { bg: "#E5E7EB", text: "#374151" }; // gray
  }
};
export default TeamPermission;
